<template>
  <div class="app-container" style="padding: 18px;background-color: #f7f8fa;">
    <el-container direction="vertical"
      style="padding: 0px 28px;background-color: #fff;border-radius: 8px;padding-bottom: 20px;">
      <el-row>
        <div style="font-size: 24px;font-weight: bolder;margin-top: 10px;">肺癌管理</div>
        <el-row style="background-color: #d5d5d5;height: 0.5px;width: 100%;margin-top: 12px;" />
      </el-row>

      <el-row style="padding: 10px 0px;">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="一体化方案" name="1">
            <managementPlan :pInfo="pInfo" />
          </el-tab-pane>
          <el-tab-pane label="随访" name="3">
            <followupRecord :pInfo="pInfo" />
          </el-tab-pane>
          <el-tab-pane label="协诊" name="2">
            <consultationRecord :pInfo="pInfo" />
          </el-tab-pane>
        </el-tabs>
      </el-row>

    </el-container>
  </div>
</template>

<script>
import managementPlan from "./managementPlan.vue";
import consultationRecord from "./consultationRecord.vue";
import followupRecord from "./followupRecord.vue";

export default {
  components: {
    managementPlan,
    consultationRecord,
    followupRecord
  },
  props: {
    pInfo: null
  },
  data() {
    return {
      activeName: '1',
    };
  },
  created() { },
  methods: {
    handleClick(tab, event) {
      console.warn(tab, event);
    }
  }
};
</script>

<style lang="scss" scoped></style>
